import React from 'react'
import {
    DatabaseOutlined,
    FileExcelOutlined,
    FileTextOutlined,
    FunctionOutlined,
    JavaOutlined,
    JavaScriptOutlined,
    PythonOutlined,
} from '@ant-design/icons'

export const LANGUAGES = {
    EXCEL: {
        name: 'Excel',
        value: 'xlsx',
        isCS: false,
    },
    TEXT: {
        name: 'Text',
        value: 'txt',
        mimeValue: 'htmlmixed',
        codemirrorImportPath: 'codemirror/mode/xml/xml',
        isCS: true,
    },
    NEW_TEXT: {
        name: 'New Text',
        value: 'free_txt',
        mimeValue: 'htmlmixed',
        codemirrorImportPath: 'codemirror/mode/xml/xml',
        isCS: false,
    },
    PYTHON: {
        name: 'Python',
        value: 'py',
        monacoValue: 'python',
        mimeValue: 'python',
        codemirrorImportPath: 'codemirror/mode/python/python',
        linterAvailable: true,
        isCS: true,
    },
    PYTHON3: {
        name: 'Python 3',
        value: 'py3',
        monacoValue: 'python',
        mimeValue: 'python',
        codemirrorImportPath: 'codemirror/mode/python/python',
        linterAvailable: true,
        isCS: true,
    },
    JAVA: {
        name: 'Java',
        value: 'java',
        monacoValue: 'java',
        mimeValue: 'text/x-java',
        codemirrorImportPath: 'codemirror/mode/clike/clike',
        linterAvailable: true,
        isCS: true,
    },
    JAVASCRIPT: {
        name: 'JavaScript',
        value: 'js',
        monacoValue: 'javascript',
        mimeValue: 'text/javascript',
        codemirrorImportPath: 'codemirror/mode/javascript/javascript',
        isCS: true,
    },
    CPP: {
        name: 'C++',
        value: 'cpp',
        monacoValue: 'cpp',
        mimeValue: 'text/x-c++src',
        codemirrorImportPath: 'codemirror/mode/clike/clike',
        linterAvailable: true,
        isCS: true,
    },
    C: {
        name: 'C',
        value: 'c',
        monacoValue: 'c',
        mimeValue: 'text/x-csrc',
        codemirrorImportPath: 'codemirror/mode/clike/clike',
        linterAvailable: true,
        isCS: true,
    },
    MATLAB: {
        name: 'Matlab',
        value: 'm',
        monacoValue: 'cpp', // matlab is not supported by monaco yet
        mimeValue: 'text/x-octave',
        codemirrorImportPath: 'codemirror/mode/octave/octave',
        isCS: true,
    },
    SQL: {
        name: 'SQL',
        value: 'sql',
        monacoValue: 'sql',
        mimeValue: 'text/x-sql',
        codemirrorImportPath: 'codemirror/mode/sql/sql',
        linterAvailable: true,
        isCS: true,
    },
    HPP: {
        name: 'H++',
        value: 'hpp',
        monacoValue: 'cpp',
        mimeValue: 'text/x-c++hdr',
        codemirrorImportPath: 'codemirror/mode/clike/clike',
        linterAvailable: true,
        isCS: true,
    },
}

const LANGUAGE_VALUE_TO_NAME = Object.fromEntries(Object.values(LANGUAGES).map(lang => [lang.value, lang.name]))
export const getLanguageName = languageValue => LANGUAGE_VALUE_TO_NAME[languageValue] || languageValue

export const CS_LANGUAGES = Object.values(LANGUAGES)
    .filter(language => language.isCS && language.value)
    .map(language => language.value)

export const NON_CS_LANGUAGES = Object.values(LANGUAGES)
    .filter(language => !language.isCS && language.value)
    .map(language => language.value)

export const getLanguageIcon = languageValue => {
    switch (languageValue) {
        case 'py':
        case 'py3':
            return <PythonOutlined />
        case 'java':
            return <JavaOutlined />
        case 'js':
            return <JavaScriptOutlined />
        case 'sql':
            return <DatabaseOutlined />
        case 'xlsx':
            return <FileExcelOutlined />
        case 'txt':
        case 'free_txt':
            return <FileTextOutlined />
        case 'm':
            return <FunctionOutlined />
        default:
            return null
    }
}
